import { STATUS_CONFIG } from "@/lib/status";

export const StatusBadge = ({ status, className = "" }) => {
  const cfg = STATUS_CONFIG[status] || STATUS_CONFIG.upcoming;
  const Icon = cfg.icon;
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-medium whitespace-nowrap ${cfg.badge} ${className}`}
      data-testid={`status-badge-${status}`}
    >
      <Icon className="h-3.5 w-3.5" />
      {cfg.label}
    </span>
  );
};
